import styles from './index.module.sass';
import ArrowDown from '../../images/arrow-down-short.svg';
import { useEffect, useRef, useState } from 'react';
import { IRustmixBuyer } from '../../ts/rustmix-buyer.types';
import { useStore } from 'effector-react';
import {
  $rustmixBuyers,
  $selectedRustmixBuyer,
  fetchOffersMatrix,
  fetchRustmixBuyersFx,
  getRustmixBuyers,
  setDataFromLs,
  setSelectedRustmixBuyer,
  switchAllRustmixBuyersState,
  switchSingleRustmixBuyerState,
} from '../../store/calculator.store';
import { ButtonMain } from '@/modules/common/components/button';
import { Checkbox, Modal } from 'antd';
import { BuyerItem } from './components/buyer-item';
import { isArray } from 'lodash-es';

export const SelectBuyer = ({
  onClick,
}: {
  onClick?: (buyer: IRustmixBuyer) => void;
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(-1);
  const rustmixBuyers = useStore($rustmixBuyers);
  const options = rustmixBuyers.data;

  const checkStores = (options: IRustmixBuyer[]) => {
    let result = true;
    isArray(options) && options.map((item) => {
      if (!item.local_enabled) {
        result = false;
      }
    });
    return result;
  };

  useEffect(() => {
    fetchRustmixBuyersFx();
  }, [])

  useEffect(() => {
    fetchOffersMatrix({ payload: options });
  }, [options]);

  // useEffect(() => {
  //   setDataFromLs();
  // }, [showModal]);

  return (
    <div className={styles.root}>
      <ButtonMain
        className={styles.selectButton}
        label="выбрать покупателей"
        onClick={() => {setShowModal(true)}}
      />
      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        closable={true}
        title={'покупатели, которые учитываются при расчетах'}
        width={'50%'}
      >
        <div className={styles.modalRoot}>
          <div
            className={styles.topBlock}
            onClick={() =>
              switchAllRustmixBuyersState({ enabled: !checkStores(options) })
            }
          >
            <Checkbox checked={checkStores(options)} title="выбрать всех покупателей" />
            <span>выбрать всех покупателей</span>
          </div>
          <div className={styles.bottomBlock}>
            {options && options?.map((item, i) => (
              <BuyerItem
                key={i}
                name={item.company_name}
                enabled={item.local_enabled}
                id={item.id}
                offersCount={item?.offers_count as number} // temporarily
                onChange={(val) =>
                  switchSingleRustmixBuyerState({ id: item.id, enabled: val })
                } // switchBuyerState(item, !item.enabled)
                onClick={() => {
                  onClick && onClick(item);
                  setSelectedId(item.id);
                }}
                selectedRustmixBuyer={selectedId}
              />
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};
